<template>
  <div>
    <v-list dense>
      <v-list-item :to="{ name: 'miPerfil' }">
        <v-list-item-avatar size="50">
          <v-avatar :color="authUser.color">
            <span class="white--text headline">{{ authUser.avatar }}</span>
          </v-avatar>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ authUser.name }} {{ authUser.apellidos }}</v-list-item-title>
          <v-list-item-subtitle>Sesión iniciada</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>

      <template v-for="item in $router.options.routes">
        <v-list-item
          v-if="mostrar(item)"
          :key="item.meta.menuText"
          link
          :to="{ name: item.name }"
          exact
        >
          <v-list-item-action>
            <v-icon>{{ item.meta.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.meta.menuText }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list-item @click.stop="comprobarRuta">
        <v-list-item-action>
          <v-icon>mdi-exit-to-app</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Cerrar sesión</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import axios from 'axios'
  import { redirect } from '../../utils/redirect'
  axios.defaults.withCredentials = true
  axios.defaults.baseURL = process.env.VUE_APP_API_URL
  export default {
    name: 'UserMenu',
    props: ['drawerRight'],
    methods: {
      ...mapActions('login', ['setUser', 'setForzadoCerrarSesion']),
      ...mapActions(['setLoading']),
      ...mapActions('arditimer', ['setAutoGuardado', 'setCerrarSesion']),
      async comprobarRuta() {
        if (this.$route.path == '/arditimer') {
          this.setLoading(true)
          this.setAutoGuardado(!this.autoGuardado) //forzamos el guardado de los timers
          this.setCerrarSesion(true)
        } else {
          this.logout()
        }
      },
      async logout() {
        redirect('logout')
      },
      mostrar(item) {
        // Por cada ruta de la aplicación, se verifica si está configurada para mostrarse en el menú del usuario (menú derecho)
        if (item.meta && item.meta.displayIn === 'userMenu') {
          return true
        }
        return false
      },
    },
    watch: {
      forzadoCerrarSesion() {
        if (this.forzadoCerrarSesion == true) {
          this.logout()
          this.setForzadoCerrarSesion(false)
        }
      },
    },
    computed: {
      ...mapState('login', ['authUser', 'forzadoCerrarSesion']),
      ...mapState('arditimer', ['autoGuardado', 'cerrarSesion']),
    },
  }
</script>
<style>
  .v-list-item__avatar {
    justify-content: center;
  }
</style>
